var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.$t(_vm.isAddForecast ? "addForecast" : "forecastDetail"),
      rightMethod: _vm.submit,
      rightButtonDisabled: _vm.isEmpty,
      hasAlert: "",
      rightButtonLoading: _vm.isLoading,
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("close")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _vm.isAddForecast
              ? _c(
                  "v-flex",
                  { attrs: { md7: "" } },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", "justify-space-between": "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { md3: "" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                items: _vm.forecastWarehouses,
                                "item-text": "warehouseName",
                                "item-value": "warehouseKey",
                                "return-object": "",
                                label: _vm.$t("warehouse")
                              },
                              model: {
                                value: _vm.forecast.curWarehouse,
                                callback: function($$v) {
                                  _vm.$set(_vm.forecast, "curWarehouse", $$v)
                                },
                                expression: "forecast.curWarehouse"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-flex"),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { md3: "" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                items:
                                  (_vm.forecast.curWarehouse &&
                                    _vm.forecast.curWarehouse.sites) ||
                                  [],
                                label: _vm.$t("warehouseSite"),
                                "item-text": "siteName",
                                "item-value": "key",
                                "return-object": false
                              },
                              model: {
                                value: _vm.forecast.warehouseSite,
                                callback: function($$v) {
                                  _vm.$set(_vm.forecast, "warehouseSite", $$v)
                                },
                                expression: "forecast.warehouseSite"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-flex"),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { md3: "" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                items: [
                                  { text: _vm.$t("air"), value: "air" },
                                  { text: _vm.$t("ocean"), value: "ocean" },
                                  { text: _vm.$t("ground"), value: "ground" }
                                ],
                                "item-text": "text",
                                "item-value": "value",
                                label: _vm.$t("shipType")
                              },
                              model: {
                                value: _vm.forecast.shipType,
                                callback: function($$v) {
                                  _vm.$set(_vm.forecast, "shipType", $$v)
                                },
                                expression: "forecast.shipType"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isAddForecast || _vm.forecast.status === "ready"
              ? _c(
                  "v-flex",
                  [
                    _c(
                      "v-layout",
                      { attrs: { "justify-space-between": "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { md11: "" } },
                          [
                            _c(
                              "v-layout",
                              [
                                _c(
                                  "v-flex",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "primary",
                                          title: "importFile",
                                          loading: _vm.isUploading,
                                          disabled: _vm.isUploadBtnDisabled
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { dark: "", left: "" } },
                                          [_vm._v("cloud_upload")]
                                        ),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("upload")) +
                                            "\n                "
                                        ),
                                        _c("input", {
                                          staticClass: "hideInput",
                                          attrs: {
                                            type: "file",
                                            accept: ".csv,.xls,.xlsx"
                                          },
                                          on: { change: _vm.uploadForecast }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { attrs: { "mr-4": "" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { color: "primary" },
                                        on: {
                                          click: function($event) {
                                            _vm.isAddPackage = true
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { dark: "", left: "" } },
                                          [_vm._v("add")]
                                        ),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("package")) +
                                            "\n              "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-flex", {
                                  attrs: { "mr-5": "", md2: "" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { color: "primary" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.downloadTemplate.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mx-2",
                                            attrs: { dark: "", left: "" }
                                          },
                                          [_vm._v("cloud_download")]
                                        ),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("template")) +
                                            "\n              "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "primary",
                                          disabled:
                                            _vm.forecast.pkgItems &&
                                            _vm.forecast.pkgItems.length < 1
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.checkTracking.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mx-2",
                                            attrs: { dark: "", left: "" }
                                          },
                                          [
                                            _vm._v(
                                              "signal_wifi_statusbar_connected_no_internet_4"
                                            )
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("checkTracking")) +
                                            "\n              "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "primary",
                                          disabled:
                                            _vm.forecast.pkgItems &&
                                            _vm.forecast.pkgItems.length < 1
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.checkUpc.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mx-2",
                                            attrs: { dark: "", left: "" }
                                          },
                                          [
                                            _vm._v(
                                              "signal_wifi_statusbar_connected_no_internet_4"
                                            )
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("checkUPC")) +
                                            "\n              "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          {
                            attrs: {
                              xs4: "",
                              md2: "",
                              right: "",
                              id: "text-field"
                            }
                          },
                          [
                            _c("v-text-field", {
                              attrs: {
                                "append-icon": "filter_list",
                                label: _vm.$t("tracking"),
                                "single-line": "",
                                "hide-details": "",
                                clearable: ""
                              },
                              model: {
                                value: _vm.filter,
                                callback: function($$v) {
                                  _vm.filter = $$v
                                },
                                expression: "filter"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("v-data-table", {
              staticClass: "elevation-2 myDense",
              attrs: {
                headers: _vm.headers,
                search: _vm.filter,
                "item-key": "tracking",
                items: _vm.forecast.pkgItems || [],
                "rows-per-page-items": _vm.rowPerPage
              },
              scopedSlots: _vm._u([
                {
                  key: "items",
                  fn: function(props) {
                    return [
                      _c(
                        "td",
                        { staticClass: "text-xs-left" },
                        [
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                {
                                  class:
                                    _vm.isCheckTracking &&
                                    !_vm.isTrackingNumberValid(
                                      props.item.tracking
                                    )
                                      ? "partial_highlight"
                                      : ""
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(props.item.tracking) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              props.item.isCheckPackage &&
                              _vm.isPackageManagementOrg(
                                (_vm.forecast.curWarehouse &&
                                  _vm.forecast.curWarehouse.warehouseKey) ||
                                  _vm.forecast.warehouseKey
                              )
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(data) {
                                              return [
                                                _c(
                                                  "div",
                                                  _vm._g({}, data.on),
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("add_task")
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("needCheckPackage"))
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "text-xs-left" },
                        _vm._l(props.item.upcs, function(pkgItem, index) {
                          return _c(
                            "v-flex",
                            { key: index },
                            [
                              _c(
                                "v-flex",
                                {
                                  class:
                                    _vm.isCheckUpc &&
                                    !_vm.isUpcValid(pkgItem.upc)
                                      ? "partial_highlight"
                                      : ""
                                },
                                [_vm._v(_vm._s(pkgItem.upc))]
                              )
                            ],
                            1
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "text-xs-left" },
                        _vm._l(props.item.upcs, function(pkgItem, index) {
                          return _c(
                            "v-flex",
                            { key: pkgItem.upc + index },
                            [
                              _c(
                                "v-flex",
                                {
                                  class:
                                    _vm.forecast.status &&
                                    _vm.forecast.status === "partial" &&
                                    pkgItem.forecastQty !== pkgItem.inboundQty
                                      ? "partial_highlight"
                                      : ""
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        !_vm.isAddForecast
                                          ? (pkgItem.forecastQty || 0) +
                                              " / " +
                                              (pkgItem.inboundQty || 0)
                                          : "" + (pkgItem.forecastQty || 0)
                                      )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "text-xs-left" },
                        _vm._l(props.item.upcs, function(pkgItem, index) {
                          return _c("v-flex", { key: index }, [
                            _c("div", { staticClass: "textOverflowHide" }, [
                              _vm._v(
                                _vm._s(
                                  pkgItem.productName ||
                                    _vm.getProductName(pkgItem.upc) ||
                                    ""
                                )
                              )
                            ])
                          ])
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "text-xs-center" },
                        [
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    color: "primary",
                                    disabled:
                                      props.item.upcs.reduce(function(
                                        qty,
                                        item
                                      ) {
                                        return qty + item.inboundQty
                                      },
                                      0) > 0
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.editPkg(props.item)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("edit")) + "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    color: "primary",
                                    disabled:
                                      props.item.upcs.reduce(function(
                                        qty,
                                        item
                                      ) {
                                        return qty + item.inboundQty
                                      },
                                      0) > 0
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.deletePkg(props.item)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("delete")) + "\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { "mt-3": "" } },
              [
                _c("v-textarea", {
                  staticClass: "thinBox",
                  attrs: {
                    label: _vm.$t("note"),
                    outline: "",
                    disabled:
                      _vm.forecast.status && _vm.forecast.status !== "ready",
                    rows: "5",
                    counter: "200"
                  },
                  model: {
                    value: _vm.forecast.note,
                    callback: function($$v) {
                      _vm.$set(_vm.forecast, "note", $$v)
                    },
                    expression: "forecast.note"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.isAddPackage
              ? _c("FormSubmitPopup", {
                  attrs: {
                    title: _vm.$t("addPackage"),
                    rightMethod: _vm.savePackage,
                    rightButtonDisabled:
                      _vm.isAddPkgEmpty || _vm.isDuplicateUpc,
                    hasAlert: "",
                    rightButtonLoading: _vm.isLoading,
                    medium: ""
                  },
                  on: {
                    popupClose: function() {
                      _vm.isAddPackage = false
                      _vm.isEditItem = false
                      _vm.reset()
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function() {
                          return [
                            _c(
                              "v-flex",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { md4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            disabled: _vm.isEditItem,
                                            rules: [
                                              _vm.fieldIsRequired(
                                                "trackingNumber"
                                              )
                                            ],
                                            label: _vm.$t("trackingNumber")
                                          },
                                          model: {
                                            value: _vm.pkg.tracking,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.pkg,
                                                "tracking",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "pkg.tracking"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md2: "" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { color: "primary" },
                                            on: { click: _vm.addUPC }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { dark: "", left: "" } },
                                              [_vm._v("add")]
                                            ),
                                            _vm._v("UPC ")
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md3: "" } },
                                      [
                                        _vm.isPackageManagementOrg(
                                          (_vm.forecast.curWarehouse &&
                                            _vm.forecast.curWarehouse
                                              .warehouseKey) ||
                                            _vm.forecast.warehouseKey
                                        )
                                          ? _c(
                                              "v-tooltip",
                                              {
                                                attrs: { top: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(data) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            _vm._g({}, data.on),
                                                            [
                                                              _c("v-checkbox", {
                                                                attrs: {
                                                                  label: _vm.$t(
                                                                    "checkPackage"
                                                                  )
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.pkg
                                                                      .isCheckPackage,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.pkg,
                                                                      "isCheckPackage",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "pkg.isCheckPackage"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  3846239463
                                                )
                                              },
                                              [
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("isCheckPackage")
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md3: "", right: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "append-icon": "filter_list",
                                            label: _vm.$t("upc"),
                                            "single-line": "",
                                            "hide-details": "",
                                            clearable: ""
                                          },
                                          model: {
                                            value: _vm.upcFilter,
                                            callback: function($$v) {
                                              _vm.upcFilter = $$v
                                            },
                                            expression: "upcFilter"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.pkg.upcs || [], function(item, index) {
                              return _c(
                                "v-flex",
                                { key: index },
                                [
                                  !(_vm.upcFilter && item.upc !== _vm.upcFilter)
                                    ? _c(
                                        "v-layout",
                                        {
                                          attrs: { "justify-space-between": "" }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md4: "", "mr-5": "" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  "hide-details": "",
                                                  rules: [
                                                    _vm.fieldIsRequired("upc")
                                                  ],
                                                  label: _vm.$t("upc")
                                                },
                                                model: {
                                                  value: item.upc,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "upc",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression: "item.upc"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { md4: "", "mr-4": "" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  "hide-details": "",
                                                  label: _vm.$t("productName")
                                                },
                                                model: {
                                                  value: item.productName,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "productName",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression: "item.productName"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { md3: "", right: "" } },
                                            [
                                              _c(
                                                "v-layout",
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      "hide-details": "",
                                                      rules: [
                                                        _vm.fieldIsNumber()
                                                      ],
                                                      label: _vm.$t("quantity")
                                                    },
                                                    model: {
                                                      value: item.forecastQty,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "forecastQty",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "item.forecastQty"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticStyle: {
                                                        cursor: "'pointer'"
                                                      },
                                                      attrs: { color: "red" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.pkg.upcs.splice(
                                                            index,
                                                            1
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("cancel")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    1961277201
                  ),
                  model: {
                    value: _vm.isAddPackage,
                    callback: function($$v) {
                      _vm.isAddPackage = $$v
                    },
                    expression: "isAddPackage"
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68dc8840", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68dc8840","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForecastDetailPopup.vue
// module id = null
// module chunks = 